var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"page-header"},[_c('LogoHeader',{attrs:{"isLink":true,"noSep":true,"position":_vm.left,"path":'/index'}}),_c('h1',[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }